// extracted by mini-css-extract-plugin
export default {"dashboard":"Support_dashboard__tuohL","wrapper":"Support_wrapper__R-2r3"};